import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FaTimes, FaEye, FaUserCheck, FaPercent,
} from 'react-icons/fa';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { json2excel } from 'js2excel';

import {
  LineChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

import Modal from '~/Components/Modal';
import Button from '~/Components/Button';

import calendarImg from '~/Assets/Images/calendar.png';
import costTotalImg from '~/Assets/Images/cost-total.png';
import sendMessageImg from '~/Assets/Images/send-message.png';
import coinImg from '~/Assets/Images/coin.png';

import {
  Row,
  ModalWrap,
  RowHeader,
  RowContent,
  ButtonCloseModal,
  BaseCost,
  Cost,
  Img,
  Card,
  FormGroup,
  Table,
} from './styles';

import { Creators as ReportActions } from '~/redux/ducks/report';
import { convertFloatReal } from '~/Utils';

class ModalResults extends Component {
  renderAudiencia = () => {
    const {
      gridPeriodReport: { campaign },
    } = this.props;

    return (
      <div className="audience">
        <Row style={{ marginBottom: 0 }}>
          <BaseCost className="full">
            <Cost className="full">
              <Img alt="Moeda" src={coinImg} />
              <div className="desc-box">
                <p>Custo Acordado(R$):</p>
                <span>
                  {convertFloatReal(campaign.costVlr)}
                </span>
              </div>
            </Cost>
          </BaseCost>
        </Row>
      </div>
    );
  };

  renderEfetuado = () => {
    const {
      gridPeriodReport: { campaign },
    } = this.props;

    return (
      <>
        <Row style={{ marginRight: -20 }}>
          <Card>
            <Img alt="Bolsa Dinheiro" src={costTotalImg} />
            <FormGroup>
              <span>
                Investimento(R$)
              </span>
              <label className="card-value">{campaign.investiment.toLocaleString('pt-BR')}</label>
            </FormGroup>
          </Card>
          <Card>
            <Img alt="Avião Papel" src={sendMessageImg} />
            <FormGroup>
              <span>
                Disparos
              </span>
              <label className="card-value">{campaign.volume.toLocaleString('pt-BR')}</label>
            </FormGroup>
          </Card>
          <Card>
            <FaEye />
            <FormGroup>
              <span>
                Impressões
              </span>
              <label className="card-value">{campaign.delivered.toLocaleString('pt-BR')}</label>
            </FormGroup>
          </Card>
          <Card>
            <FaUserCheck />
            <FormGroup>
              <span>
                Conversão
              </span>
              <label className="card-value">{campaign.total.toLocaleString('pt-BR')}</label>
            </FormGroup>
          </Card>
          <Card>
            <FaPercent />
            <FormGroup>
              <span>
                % Conversão
              </span>
              <label className="card-value">
                {parseFloat(campaign.conversionRate).toFixed(2).toLocaleString('pt-BR')}
              </label>
            </FormGroup>
          </Card>
        </Row>
      </>
    );
  };

  renderTable = () => {
    const {
      gridPeriodReport,
    } = this.props;
    return (
      <Table>
        <thead>
          <tr>
            <th>Data</th>
            <th>Disparos</th>
            <th>Impressões</th>
            <th>Conversão</th>
            <th>Custo</th>
          </tr>
        </thead>
        <tbody>
          {gridPeriodReport.data.map(event => (
            <tr key={event}>
              <td>{event.dateEvent}</td>
              <td>{event.volume || 0}</td>
              <td>{event.sentQty || 0}</td>
              <td>{event.clickQty || 0}</td>
              <td>{convertFloatReal(event.costVlr || 0)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  renderChartAcumulado = () => {
    const {
      gridPeriodReport: { accumulated },
    } = this.props;
    return (
      <Row>
        <LineChart
          width={1250}
          height={300}
          data={accumulated}
          margin={{
            top: 5,
            right: 10,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="dateEvent" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="volume"
            name="Disparo"
            stroke="#9B34FF"
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey="sentQty"
            name="Impressão"
            stroke="#E42792"
          />
          <Line
            type="monotone"
            dataKey="clickQty"
            name="Conversão"
            stroke="#10C8FE"
          />
        </LineChart>
      </Row>
    );
  };

  renderChartEventos = () => {
    const {
      gridPeriodReport: { data },
    } = this.props;
    return (
      <Row>
        <AreaChart
          width={1250}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 10,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="dateEvent" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Area
            type="monotone"
            dataKey="volume"
            name="Disparo"
            stroke="#9B34FF"
            fill="#D5ACFC"
          />
          <Area
            type="monotone"
            dataKey="sentQty"
            name="Impressão"
            stroke="#E42792"
            fill="#FB9ED3"
          />
          <Area
            type="monotone"
            dataKey="clickQty"
            name="Conversão"
            stroke="#10C8FE"
            fill="#B2ECFD"
          />
        </AreaChart>
      </Row>
    );
  };

  handleExportToExcel = () => {
    const { gridPeriodReport } = this.props;
    // const data = [
    //   {
    //     Data: '10/10/2019',
    //     Disparos: 100000 || 0,
    //     Impressões: 150000 || 0,
    //     Conversão: 20000 || 0,
    //     Custo: convertFloatReal(0.15 || 0),
    //   },
    // ];
    const data = gridPeriodReport.data.map(event => (
      {
        Data: event.dateEvent,
        Disparos: event.volume || 0,
        Impressões: event.sentQty || 0,
        Conversão: event.clickQty || 0,
        Custo: convertFloatReal(event.costVlr || 0),
      }
    ));
    try {
      json2excel({
        data,
        name: 'Relatório',
        formateDate: 'dd/mm/yyyy',
      });
    } catch (e) {
      console.error('export error', e);
    }
  }

  render() {
    const {
      gridPeriodReport,
      reportGridPeriodLoadReportDataSuccess,
    } = this.props;

    return gridPeriodReport && (
      <Modal width={1300} height={800} scroll={false} padding={0}>
        <ModalWrap>
          <RowHeader>
            <Row>
              <h1>Relatório</h1>
              <ButtonCloseModal
                type="button"
                onClick={() => {
                  reportGridPeriodLoadReportDataSuccess(null);
                }}
              >
                <FaTimes size={30} />
              </ButtonCloseModal>
            </Row>
            <Row style={{ alignItems: 'center' }}>
              <div className="header-campaign">
                <h2>{gridPeriodReport.campaign.name}</h2>
              </div>
              <div className="header-chanel">
                <h2>
                  {`${gridPeriodReport.campaign.channel} (${gridPeriodReport.campaign.zone})`}
                </h2>
              </div>
              <div className="header-action">
                <Button
                  bordered
                  icon="FaFileExcel"
                  title="Exportar"
                  onClick={() => {
                    this.handleExportToExcel();
                  }}
                  type="button"
                />
              </div>
            </Row>
          </RowHeader>
          <RowContent>
            <div id="CHART" className="campaign">
              <Row>
                <BaseCost>
                  <Cost>
                    <Img alt="Push Notification" src={calendarImg} />
                    <div className="desc-box">
                      <p>Data Inicio </p>
                      <span>{moment(gridPeriodReport.campaign.startDate).format('DD/MM/YYYY')}</span>
                    </div>
                  </Cost>
                  <Cost>
                    <div className="desc-box">
                      <p>Data Fim </p>
                      <span>{moment(gridPeriodReport.campaign.endDate).format('DD/MM/YYYY')}</span>
                    </div>
                  </Cost>
                </BaseCost>
                {this.renderAudiencia()}
              </Row>
              <h3>Total Efetuado</h3>
              {this.renderEfetuado()}

              <h3>Acumulado</h3>
              {this.renderChartAcumulado()}

              <h3>Eventos</h3>
              {this.renderChartEventos()}

              {this.renderTable()}
            </div>
          </RowContent>
        </ModalWrap>
      </Modal>
    );
  }
}

ModalResults.defaultProps = {
  gridPeriodReport: null,
};

ModalResults.propTypes = {
  reportGridPeriodLoadReportDataSuccess: PropTypes.func.isRequired,
  gridPeriodReport: PropTypes.shape(),
};

const mapStateToProps = state => ({
  gridPeriodReport: state.report.gridPeriodReport,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    // report actions
    reportGridPeriodLoadReportDataSuccess: ReportActions.reportGridPeriodLoadReportDataSuccess,
  },
  dispatch,
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalResults);
